import {CurrentModalEnum} from "./AccountInfo";
import React from "react";
import {Citizenship} from "./Modals/Citizenship";
import {ChangePassport} from "./Modals/ChangePassport";
import {ChangePersonalInfo} from "./Modals/ChangePersonalInfo";
import styled from "styled-components/macro";
import {ChangeSocialNumber} from "./Modals/ChangeSocialNumber";
import {WindowSizePXEnum} from "../../../interface/Basic/window";

export interface CurrentModalProps {
    currentModal: CurrentModalEnum

    onGoBack(): void

    onGoInfoModal(): void

    isInfoModalOpen: boolean
}

export interface ModalContentProps {

    onGoBack(): void

    onGoInfoModal(): void

    isInfoModalOpen: boolean
}

export const ModalContent = ({currentModal, onGoBack, onGoInfoModal, isInfoModalOpen}: CurrentModalProps) => {

    const router = () => {
        switch (currentModal) {

            case CurrentModalEnum.Personal: {
                return <ChangePersonalInfo onGoBack={onGoBack} onGoInfoModal={onGoInfoModal} isInfoModalOpen={isInfoModalOpen}/>
            }
            case CurrentModalEnum.Passport: {
                return <ChangePassport onGoBack={onGoBack} onGoInfoModal={onGoInfoModal} isInfoModalOpen={isInfoModalOpen}/>
            }
            case CurrentModalEnum.Citizenhsip: {
                return <Citizenship onGoBack={onGoBack} onGoInfoModal={onGoInfoModal} isInfoModalOpen={isInfoModalOpen}/>
            }
            case CurrentModalEnum.SocialNumber: {
                return <ChangeSocialNumber onGoBack={onGoBack} onGoInfoModal={onGoInfoModal} isInfoModalOpen={isInfoModalOpen}/>
            }
            default : {
                return <ChangePersonalInfo onGoBack={onGoBack} onGoInfoModal={onGoInfoModal} isInfoModalOpen={isInfoModalOpen}/>
            }
        }
    }


    return <ModalContainer>
        {router()}
    </ModalContainer>
}

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
  }
`
